namespace TabAurous.HR {
    export interface SalaryPackageDetailsRow {
        SalaryPackageDetailsId?: number;
        SalaryPackageId?: number;
        ComponentId?: number;
        Code?: string;
        Type?: Common.SalaryComponentType;
        Amount?: number;
        Percentage?: number;
        Narration?: string;
    }

    export namespace SalaryPackageDetailsRow {
        export const idProperty = 'SalaryPackageDetailsId';
        export const nameProperty = 'Narration';
        export const localTextPrefix = 'HR.SalaryPackageDetails';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SalaryPackageDetailsId = "SalaryPackageDetailsId",
            SalaryPackageId = "SalaryPackageId",
            ComponentId = "ComponentId",
            Code = "Code",
            Type = "Type",
            Amount = "Amount",
            Percentage = "Percentage",
            Narration = "Narration"
        }
    }
}
